import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=252fd8b5&scoped=true"
import script from "./Lightbox.vue?vue&type=script&lang=js"
export * from "./Lightbox.vue?vue&type=script&lang=js"
import style0 from "./Lightbox.vue?vue&type=style&index=0&id=252fd8b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252fd8b5",
  null
  
)

export default component.exports